import { render, staticRenderFns } from "./ApplicationsLanding.vue?vue&type=template&id=55fa70f6"
import script from "./ApplicationsLanding.vue?vue&type=script&lang=js"
export * from "./ApplicationsLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports